import React from 'react';
import './App.css';

function App() {
  const siteName = 'Sevens 7 Jeans';
  document.title = siteName;
  return <div className="App">{siteName}</div>;
}

export default App;
